module.exports = __webpack_public_path__ + "img/first_year_premium_white.61c16c0.svg";